<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav title="StakeVault" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="flex items-center justify-between">
					<div class="staking-bg-image p-30">
						<div class="flex items-center justify-between">
							<span class="text-24 text-#ccc">{{$t("质押.质押中")}}</span>
							<img class="w-50 h-50" src="@/assets/images/pages/staking/zy.png" alt="" />
						</div>
						<div class="mt-30">
							<span class="text-46 font-bold" style="color: #EB470C;">{{pledge_roon_ing}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#eee">ROON</span>
						</div>
					</div>
					<div class="staking-bg-image  p-30">
						<div class="flex items-center justify-between">
							<span class="text-24 text-#ccc">{{$t("质押.收益")}}</span>
							<img class="w-50 h-50" src="@/assets/images/pages/staking/sy.png" alt="" />
						</div>
						<div class="mt-30">
							<span class="text-46 font-bold" style="color: #EB470C;">{{pledge_roon_static}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#eee">ROON</span>
						</div>
					</div>
				</div>
				<div class="mt-20">
					<div>
						<span class="text-40 text-white">{{$t("质押.ROON锁仓")}}</span>
					</div>
					<div class="mt-20 flex flex-wrap">
						<div @click="form.type = item.id" v-for="(item, index) in pledge_roon" :key="index"
						:class="[item.id == form.type ? 'border-#FF5134 bg-#280D03' : 'border-#212122 bg-#19191A']"
							class="w-324 h-270 rounded-20 p-20  m-8 border border-solid">
							<div class="flex items-center">
								<img class="w-40 h-40" src="@/assets/images/pages/staking/sj.png" alt="" />
								<span class="ml-10 text-28 text-white font-bold">{{item.day}}{{$t("质押.天")}}</span>
							</div>
							<div class="py-30 border-b border-b-solid border-#FF5134">
								<span class="text-60 font-bold" style="color: #FF6041;">{{item.annual_yield}}%</span>
								<span class="ml-20 text-#ccc text-20">{{$t("质押.年化收益率")}}</span>
							</div>
							<div class="mt-20 flex items-center">
								<img class="w-20 h-20" src="@/assets/images/pages/staking/roon.png" alt="" />
								<span class="ml-10 text-20 text-#ccc">{{$t("质押.最低")}}{{item.min}}ROON</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-#19191A rounded-20 p-30">
						<div>
							<span class="text-36 text-white">{{$t("质押.质押金额")}}</span>
						</div>
						<div class="mt-20 bg-white/10 h-110 rounded-20 flex items-center justify-between px-20">
							<input class="flex-1 text-32 font-bold text-white" type="text" v-model="number"  placeholder="输入质押金额" />
<!--							<span class="text-32 font-bold" style="color: #2DFDFF;">{{$t("质押.最大")}}</span>-->
						</div>
<!--						<div class="mt-20 flex items-center">-->
<!--							<span class="text-24 text-#999">{{$t("质押.余额")}}</span>-->
<!--							<span class="text-24 text-primary">10,000 ROON</span>-->
<!--						</div>-->
						<div class="mt-20 flex items-center justify-center">
							<div @click="pledge" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('质押.立即质押')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between" v-if="pledge_roon_user.length > 0">
						<span class="text-40 text-white">{{$t('质押.我的质押')}}</span>
<!--						<div class="flex items-center">-->
<!--							<span class="text-24 text-#ccc">{{$t('质押.查看全部质押')}}</span>-->
<!--							<img class="ml-10 w-20 h-20" src="@/assets/images/pages/staking/more.png" alt="" />-->
<!--						</div>-->
					</div>
					<div class="mt-20" v-if="pledge_roon_user.length > 0">
						<div v-for="(item, index) in pledge_roon_user" :key="index" class="mb-20 bg-white/10 p-30 rounded-20">
							<div class="flex items-center justify-between">
								<span class="text-primary text-32 font-bold">{{item.amount}}ROON</span>
								<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid" style="border-color:#50B428; background-color: #50B42820;" v-if="item.status == 0">
									<span class="text-20 text-white">{{$t('质押.进行中')}}</span>
								</div>
                                <div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid" style="border-color:#50B428; background-color: #50B42820;" v-else-if="item.status == 1" >
                                    <span class="text-20 text-white">解压中</span>
                                </div>
                                <div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid" style="border-color:#50B428; background-color: #50B42820;" v-else>
                                    <span class="text-20 text-white">已解压</span>
                                </div>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#ccc">{{item.pledgeroon.day}}{{$t("质押.天锁定")}}</span>
								<span class="ml-30 text-20 text-primary">{{$t("质押.年百分率")}}{{item.pledgeroon.annual_yield}}%</span>
							</div>
							<div class="mt-20 flex items-center justify-between">
								<span class="text-20 text-#999">{{$t("质押.质押进度")}}</span>
								<span class="text-20 text-#999">{{$t("质押.剩余")}}{{item.surplus_day}}{{$t("质押.天")}}</span>
							</div>
					<div class="mt-20 h-16 rounded-full bg-white/10 overflow-hidden">
						<div class="h-16 bg-primary rounded-full" :style="{ width: (item.progress || 0) + '%' }"></div>
					</div>
							<div class="mt-20 flex items-center justify-between">
								<div class="flex-1">
									<div class="">
										<span class="text-20 text-#999">{{$t("质押.累计收益")}}</span>
									</div>
									<div class="mt-10">
										<span class="text-24 text-primary font-bold">+{{item.profit}}</span>
									</div>
								</div>
                                <div v-if="item.status == 0 && (Date.now()/1000) > item.end_time" class="rounded-full px-50 flex items-center justify-center h-80 bg-primary" @click="unstake(item)">
                                    <span class="text-28 text-white">解压</span>
                                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-overlay :show="paying" :z-index="9999" class-name="flex items-center justify-center">
				<div class="flex flex-col items-center justify-center h-full" @click.stop>
					<van-loading type="spinner" color="#5ACC3C" size="40px" vertical>
						<span class="mt-20 text-white text-28">{{$t('添加流动性.交易处理中')}}...</span>
					</van-loading>
				</div>
			</van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import MainTokenStakingAbi from "@/abi/MainTokenStakingAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				address: "",
				number: "",
				paying: false,
                MainTokenAddress: "0x6bA549e1ceFca4C340f6a4a5A4E0Ce4536fc2542",
                pledge_roon: [],
                pledge_roon_user: [],
				queryInfo: {
					page: 1,
					type: 1
				},
                pledge_roon_ing:0,
                pledge_roon_static:0,
				form: {
					type: 1
				}
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
		},
		created() {
            let vm = this
            vm.getIndex()
        },
		methods: {
			async unstake(item) {
                let vm = this
                this.paying = true;
				if (typeof window.ethereum === "undefined") {
					utils.showToast(this.$t("公共.请安装MetaMask") || "请安装MetaMask");
					this.paying = false;
					return;
				}

				try {

                    // 先调用后端接口，成功后再继续链上交易
                    try {
                        const resp = await ajaxData("/pledge/roon/remove", { id: item.id });
                        console.log("/pledge/roon/remove resp", resp);
                    } catch (apiErr) {
                        console.error("/pledge/roon/remove error", apiErr);
                        vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
                        this.paying = false;
                        return; // 接口异常直接结束，不继续链上操作
                    }


					const web3 = new Web3(window.ethereum);
					const chainId = await web3.eth.getChainId();
					if (chainId != 1492) {
						utils.showToast(this.$t("公共.请切换到ROON主网") || "请切换到ROON主网");
						this.paying = false;
						return;
					}

					const accounts = await window.ethereum.request({
						method: "eth_requestAccounts"
					});
					const account = accounts[0];

					const contract = new web3.eth.Contract(MainTokenStakingAbi, this.MainTokenAddress);
					contract.methods.unstake(item.stake_id).send({
						from: account
					}).on("transactionHash", hash => {
						utils.showToast(this.$t("公共.交易已发送") || "交易已发送");
					}).on("receipt", receipt => {
						utils.showToast(this.$t("公共.交易成功") || "交易成功");
						this.paying = false;
						this.getIndex();
					}).on("error", error => {
						console.log(error);
						utils.showToast(this.$t("公共.交易失败") || "交易失败");
						this.paying = false;
					});
				} catch (e) {
					console.log(e);
					utils.showToast(e.message);
					this.paying = false;
				}
			},
            async pledge() {
                if (!this.number) {
                    utils.showToast(this.$t("质押.请输入质押金额") || "请输入质押金额");
                    return;
                }
                let selected = this.pledge_roon.find(item => item.id == this.form.type);
                if (!selected) {
                    utils.showToast(this.$t("质押.请选择质押") || "请选择质押");
                    return;
                }

                if (parseFloat(this.number) < parseFloat(selected.min)) {
                    utils.showToast((this.$t("质押.最低") || "最低") + selected.min + " ROON");
                    return;
                }

                if (typeof window.ethereum === "undefined") {
                    utils.showToast(this.$t("公共.请安装MetaMask") || "请安装MetaMask");
                    return;
                }

                try {
                    const web3 = new Web3(window.ethereum);
                    const chainId = await web3.eth.getChainId();
                    if (chainId != 1492) {
                        utils.showToast(this.$t("公共.请切换到ROON主网") || "请切换到ROON主网");
                        return;
                    }
                    const accounts = await window.ethereum.request({
                        method: "eth_requestAccounts"
                    });
                    const account = accounts[0];

                    const contract = new web3.eth.Contract(MainTokenStakingAbi, this.MainTokenAddress);
                    const amount = web3.utils.toWei(this.number + "", "ether");
                    let duration = selected.day * 24 * 60 * 60;


                    // if (selected.id == 1){
                    //     duration = 1
                    // }
                    contract.methods.stake(selected.id, duration).send({
                        from: account,
                        value: amount
                    }).on("transactionHash", hash => {
                        utils.showToast(this.$t("公共.交易已发送") || "交易已发送");
                    }).on("receipt", receipt => {
                        utils.showToast(this.$t("公共.交易成功") || "交易成功");
                        this.getIndex();
                        this.number = "";
                    }).on("error", error => {
                        console.log(error);
                        utils.showToast(this.$t("公共.交易失败") || "交易失败");
                    });
                } catch (e) {
                    console.log(e);
                    utils.showToast(e.message);
                }
            },
            getIndex() {
                let vm = this
                getShowAddress()
                ajaxData("/pledge/roon").then(res => {
                    console.log(res)
                    vm.address = res.data.address;
                    vm.pledge_roon = res.data.pledge_roon;
                    vm.pledge_roon_user = res.data.pledge_roon_user;
                    vm.pledge_roon_static = res.data.pledge_roon_static;
                    vm.pledge_roon_ing = res.data.pledge_roon_ing;
                })
            },
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.staking-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/staking/itemBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>



